import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BottomPanelService } from './bottom-panel.service';
import { FeedbackEventService } from "../../../core/feedback-event.service";
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-bottom-panel',
  templateUrl: './bottom-panel.component.html',
  styleUrls: ['./bottom-panel.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({
        height: '400px'
      })),
      state('closed', style({
        height: '0'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class BottomPanelComponent implements OnInit {

  public isBottomPanelOpened: boolean;
  private feedbackClosedSubscription: Subscription;

  constructor(private bottomPanelService: BottomPanelService, private feedbackService: FeedbackEventService,) { }

  ngOnInit() {
    this.bottomPanelService.getBottomPanelOpenEvent()
      .subscribe((isBottomPanelOpened: boolean) => {
        this.isBottomPanelOpened = isBottomPanelOpened;
      });

      this.feedbackClosedSubscription =
      this.feedbackService.feedbackClosed$.subscribe(() => {
       this.closeBottomPanel();
      });
  }


  ngOnDestroy() {
    if (this.feedbackClosedSubscription) {
      this.feedbackClosedSubscription.unsubscribe();
    }
  }


  closeBottomPanel() {
    this.bottomPanelService.closeBottomPanel();

  }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/bottom-panel/bottom-panel.component.ts